export class Privilegio {}
